import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./hooks/GlobalProvider";
import Opening from "./components/UnderConstruction";
import DomainRenew from './components/Tools/DomainRenew'


ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
        <AuthProvider>
        <DomainRenew />
          <App />
        </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
